import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VBtn,{class:_vm.cssClass,style:(_vm.makeStyle({ variant: _vm.variant, contained: _vm.contained })),attrs:{"color":_vm.color,"size":_vm.size,"outlined":_vm.outlined,"rounded":_vm.rounded,"disabled":_vm.disabled,"text":_vm.text,"elevation":0},on:{"click":e => this.$emit('click',e)}},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }